import { reactive, readonly } from 'vue'

interface LightboxState {
  isOpen: boolean
  images: string[]
  index: number
}

// UI-only singleton state. Always starts closed and only mutates on client
// interaction, so it's safe to share at module scope.
const state = reactive<LightboxState>({
  isOpen: false,
  images: [],
  index: 0,
})

export function useLightbox() {
  function open(images: string[], index = 0) {
    if (!images.length) return
    state.images = images
    state.index = Math.min(Math.max(index, 0), images.length - 1)
    state.isOpen = true
  }

  function close() {
    state.isOpen = false
  }

  function next() {
    if (state.images.length > 1) {
      state.index = (state.index + 1) % state.images.length
    }
  }

  function prev() {
    if (state.images.length > 1) {
      state.index = (state.index - 1 + state.images.length) % state.images.length
    }
  }

  return { state: readonly(state), open, close, next, prev }
}
